module.exports = __webpack_public_path__ + "img/empty.f4c2781f.png";